import { useQuery } from "@tanstack/react-query"

import { 
  FINANCE_DATA_RECORD_QUERY_KEY,
  FINANCE_SOAP_RECORD_CUSTOMER_STATUS_QUERY_KEY, 
  FINANCE_DATA_FROM_MAILBOX_RECORD_QUERY_KEY,
  FINANCE_DOCUMENTS_QUERY_KEY
} from "@/constants/query"
import { 
  getFinanceDataRecordCustomers, 
  getFinanceDataRecords, 
  getFinanceDataFromMailboxRecords, 
  getFinanceDataFromMailboxRecordCustomers,
  getFinanceDocuments,
  getFinanceDocument
} from "@/http/financeDataRecord"

import { IRequestParams } from "@/types/api"


export const useFinanceDataRecordQuery = (params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getFinanceDataRecords(params || {}),
    queryKey: [FINANCE_DATA_RECORD_QUERY_KEY, params],
    retry: false
  })
}

export const useFinanceDataRecordCustomerQuery = (id: number, params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getFinanceDataRecordCustomers(params || {}, id),
    queryKey: [FINANCE_DATA_RECORD_QUERY_KEY, params, id],
    retry: false
  })
}

const FINANCE_SOAP_RECORD_CUSTOMER_STATUS = [
  {
    id: 0,
    name: "Успешно"
  },
  {
    id: 1,
    name: "Ошибка"
  },
  {
    id: 2,
    name: "Не найден"
  }
]

export const useFinanceSoapRecordCustomerStatusQuery = () => {
  return useQuery({
    queryFn: () => FINANCE_SOAP_RECORD_CUSTOMER_STATUS,
    queryKey: [FINANCE_SOAP_RECORD_CUSTOMER_STATUS_QUERY_KEY]
  })
}


export const useFinanceDataFromMailboxRecordQuery = (params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getFinanceDataFromMailboxRecords(params || {}),
    queryKey: [FINANCE_DATA_FROM_MAILBOX_RECORD_QUERY_KEY, params],
    retry: false
  })
}

export const useFinanceDataFromMailboxRecordCustomerQuery = (id: number, params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getFinanceDataFromMailboxRecordCustomers(params || {}, id),
    queryKey: [FINANCE_DATA_FROM_MAILBOX_RECORD_QUERY_KEY, params, id],
    retry: false
  })
}

export const useFinanceDocumentQuery = (params?: IRequestParams, customerId?: number | null) => {
  return useQuery({
    queryFn: () => getFinanceDocuments(params || {}, customerId || null),
    queryKey: [FINANCE_DOCUMENTS_QUERY_KEY, params],
    retry: false
  })
}

export const useFinanceDocumentByIdQuery = (id: number) => {
  return useQuery({
    queryFn: () => getFinanceDocument(id),
    queryKey: [FINANCE_DOCUMENTS_QUERY_KEY, id],
    retry: false
  })
}